export const getContextMenuCoordinates = event => ({
  // ContextMenu uses fixed positioning, so its origin must be relative to the
  // viewport. Page coordinates drift when the dashboard is scrolled.
  x: event.clientX,
  y: event.clientY,
});
